import CreatePage, { CREATION_BLOCKS } from './create'
import { connect } from 'react-redux'
import { getCampaignSelector } from 'redux/selectors/campaign'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  let blockType

  if (state.current_user.moneypools_account_type_blocked) {
    blockType = CREATION_BLOCKS.byAccountType
  } else if (state.current_user.moneypools_country_blocked) {
    blockType = CREATION_BLOCKS.byCountry
  } else if (!state.flags.allow_creation) {
    blockType = CREATION_BLOCKS.byKillSwitch
  } else if (!state.current_user.email_confirmed) {
    blockType = CREATION_BLOCKS.byUnconfirmed
  }

  return {
    blockType,
    hideClose: campaign.operatingRemotely,
    countryName: state.country.country_name,
    email: state.current_user.email,
    creationError: campaign.err,
    operatingRemotely: campaign.operatingRemotely,
    campaignType: campaign.campaign_type,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreatePage)
